exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.change-email[data-v-77b768a6] {\n  box-sizing: border-box;\n  width: 400px;\n  padding: 6px;\n  border: 1px solid #ff9fae;\n}\n.error-txt[data-v-77b768a6] {\n  color: #ff0000;\n  font-size: 0.8rem;\n}\n", ""]);

// exports
